import { useState } from 'react';
import { Link } from 'react-router-dom';

const categories = ['All', 'Public Opinion', 'Governance', 'Politics & Society', 'Technology', 'Communication'];

const posts = [
  {
    slug: 'what-communities-think',
    cat: 'Public Opinion',
    title: 'What communities actually think: a field-note from a large-sample survey',
    meta: 'Opinion Research · 12 min read',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20field%20researcher%20notebook%20with%20handwritten%20notes%20and%20a%20survey%20clipboard%20on%20a%20warm%20desk%2C%20soft%20natural%20light%2C%20deep%20green%20and%20amber%20tones%2C%20authentic%20grounded%20documentary%20mood%2C%20no%20people%20no%20logos&width=800&height=520&seq=prabhaw-insight-01&orientation=landscape',
    featured: true,
  },
  {
    slug: 'mis-built-for-people',
    cat: 'Governance',
    title: 'From data to delivery: why MIS must be built for people, not just reports',
    meta: 'Analysis · 8 min read',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20charts%20and%20printed%20dashboards%20beside%20a%20pencil%20on%20a%20minimal%20desk%2C%20deep%20emerald%20and%20amber%20gold%20tones%2C%20governance%20technology%20mood%2C%20soft%20natural%20light%2C%20no%20text%20no%20people%20no%20logos&width=800&height=520&seq=prabhaw-insight-02&orientation=landscape',
  },
  {
    slug: 'the-quiet-signal',
    cat: 'Politics & Society',
    title: 'The quiet signal: reading public mood beyond the headline',
    meta: 'Field Observation · 6 min read',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20layered%20newspaper%20clippings%20and%20notes%20on%20a%20warm%20wooden%20table%20with%20a%20coffee%20cup%2C%20soft%20window%20light%2C%20deep%20green%20and%20amber%20tones%2C%20analytical%20documentary%20mood%2C%20no%20text%20no%20people%20no%20logos&width=800&height=520&seq=prabhaw-insight-03&orientation=landscape',
  },
  {
    slug: 'building-an-intelligence-layer',
    cat: 'Technology',
    title: 'Building an intelligence layer for public institutions',
    meta: 'Technology · 9 min read',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20circuit%20patterns%20and%20data%20nodes%20glowing%20in%20deep%20emerald%20green%20and%20amber%20gold%20on%20a%20dark%20surface%2C%20premium%20technology%20aesthetic%2C%20soft%20depth%20of%20field%2C%20no%20text%20no%20people%20no%20logos&width=800&height=520&seq=prabhaw-insight-04&orientation=landscape',
  },
  {
    slug: 'iec-campaigns',
    cat: 'Communication',
    title: 'Public awareness that sticks: lessons from IEC campaigns',
    meta: 'Communication · 7 min read',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20colorful%20awareness%20posters%20and%20graphic%20prints%20arranged%20on%20a%20wall%2C%20warm%20amber%20and%20deep%20green%20palette%2C%20creative%20public%20outreach%20mood%2C%20soft%20lighting%2C%20no%20text%20no%20people%20no%20logos&width=800&height=520&seq=prabhaw-insight-05&orientation=landscape',
  },
  {
    slug: 'constituency-intelligence',
    cat: 'Governance',
    title: 'Constituency intelligence: mapping need before designing response',
    meta: 'Analysis · 10 min read',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20a%20map%20with%20marked%20points%20and%20data%20notes%20beside%20a%20laptop%20on%20a%20warm%20desk%2C%20deep%20green%20and%20amber%20tones%2C%20strategic%20field%20intelligence%20mood%2C%20soft%20natural%20light%2C%20no%20text%20no%20people%20no%20logos&width=800&height=520&seq=prabhaw-insight-06&orientation=landscape',
  },
];

export default function Insights() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? posts : posts.filter((p) => p.cat === active);
  const featured = filtered[0];

  return (
    <section id="insights" className="relative w-full bg-background-100/60 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-dots-soft opacity-40 mask-radial-fade pointer-events-none"></div>

      <div className="relative px-6 md:px-16 lg:px-28">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[10px] tracking-[0.3em] uppercase text-foreground-500 font-mono">07 / Insights</span>
            </div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-foreground-950 tracking-tight font-semibold">
              Prabhaw <span className="text-primary-700">Insights</span>
            </h2>
          </div>
          <p data-reveal="fade" className="max-w-sm text-[15px] leading-[1.8] text-foreground-600">
            Reports, analysis, field observations and opinion research from the work
            we do.
          </p>
        </div>

        {/* Category filter */}
        <div className="flex flex-wrap gap-2 mb-10">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`px-4 py-1.5 rounded-full text-xs font-mono uppercase tracking-wider transition cursor-pointer whitespace-nowrap border ${
                active === c
                  ? 'bg-primary-500 text-background-50 border-primary-500'
                  : 'bg-background-50 text-foreground-600 border-background-200 hover:border-primary-400'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {featured && (
          <div data-reveal className="group grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch rounded-2xl overflow-hidden border border-background-200 bg-background-50 mb-5">
            <Link to={`/insights/${featured.slug}`} className="img-zoom relative w-full aspect-[16/10] lg:aspect-auto lg:h-full cursor-pointer">
              <img src={featured.img} alt={featured.title} className="absolute inset-0 w-full h-full object-cover object-top" />
            </Link>
            <div className="flex flex-col justify-center p-7 md:p-10">
              <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-primary-700 font-mono">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                {featured.cat}
              </span>
              <h3 className="mt-4 text-2xl md:text-3xl leading-tight text-foreground-950 font-semibold group-hover:text-primary-700 transition-colors">
                {featured.title}
              </h3>
              <p className="mt-3 text-[13px] text-foreground-500 font-mono">{featured.meta}</p>
              <Link to={`/insights/${featured.slug}`} className="mt-6 inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-800 transition cursor-pointer whitespace-nowrap font-mono uppercase tracking-wider">
                Read insight <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        )}

        {/* Grid */}
        <div data-reveal-stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.slice(1).map((p) => (
            <Link
              key={p.title}
              to={`/insights/${p.slug}`}
              className="stagger-child group flex flex-col rounded-2xl overflow-hidden border border-background-200 bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <div className="img-zoom relative w-full aspect-[16/10]">
                <img src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover object-top" />
              </div>
              <div className="flex flex-col flex-1 p-6">
                <span className="text-[11px] tracking-[0.2em] uppercase text-primary-700 font-mono">{p.cat}</span>
                <h3 className="mt-2 text-lg leading-snug text-foreground-950 font-semibold group-hover:text-primary-700 transition-colors">
                  {p.title}
                </h3>
                <p className="mt-auto pt-4 text-[12px] text-foreground-500 font-mono">{p.meta}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}